import Question from "./Question";
import log from "loglevel";

const QuestionsList = ({ otherActivityData, questionRefs, activity_evaluated, labId, setOtherActivityData, isDisabled, labAvailableTime }) => {

    const seenQuestions = new Set();

    const updateResponse = (updateresp) => {
        log.log(" response to be updated", updateresp)
        const updatedActivityData = {
            ...otherActivityData,
            question_set: otherActivityData.question_set.map(question => {
                if (question?.id === updateresp?.id) {
                    log.log(" found --- the question")
                    return {
                        ...question,
                        questionresponse_set: updateresp
                    };
                }
                return question;
            })
        };

        // Update the state with the updated activity data
        log.log("update data --", updatedActivityData);
        setOtherActivityData(updatedActivityData)
        //  dispatch(actions.loadOtherLabs(labID));
        // dispatch(labactions.loadLabs(courseId));
    }

    return (<>
        {otherActivityData?.question_set?.filter(question => {
            const isDuplicate = seenQuestions.has(question.question_id);
            seenQuestions.add(question.question_id);
            return !isDuplicate;
        }).map((question, index) => {
            console.log('question_set_map', question, index)
            try {
                return (
                    <div className="my-3" key={question.question_id}>
                        {/* {log.log({ question, index, labId, isDisabled, activity_evaluated })} */}
                        <Question
                            question={question}
                            index={index}
                            labId={labId}
                            previousResponse={question?.questionresponse_set || { id: question?.id, response_text: "", response_options: [], response_options_ids: [] }}
                            updateResponse={updateResponse}
                            labAvailableTime={labAvailableTime}
                            dis={isDisabled || false}
                            Eval={activity_evaluated || false}
                            ref={(el) => (questionRefs.current[index] = el)}
                            isDisabled={isDisabled}
                        />
                        {log.log("inside question : ", question.questionresponse_set ? Object.keys(question.questionresponse_set) : null)}
                    </div>
                );
            } catch (error) {
                log.error("Error occurred:", error);
                return (
                    <div className="my-3" key={question.question_id}>
                        <p>Error occurred while rendering question.</p>
                    </div>
                );
            }
        })}
    </>);
}

export default QuestionsList;